// @ts-check

import React, { useEffect } from "react";

/**
 *
 * @param {{scriptId:string}} param0
 * @returns {{appendScript:()=>void}}
 */
const useAppendNewScript = ({ scriptId }) => {
  useEffect(() => {
    return () => {
      const element = document.getElementById(scriptId);
      if (element) {
        document.body.removeChild(element);
      }
    };
  }, []);
  return {
    appendScript: (payloadScript) => {
      const script = document.createElement("script");
      script.id = scriptId;
      const scriptText = document.createTextNode(payloadScript);

      script.appendChild(scriptText);
      document.body.appendChild(script);
    },
  };
};

export default useAppendNewScript;
